import { fork } from 'redux-saga/effects';

import { actions } from 'domain/sale';
import { itemNavigator } from 'sagas/common';
import { editableFields } from './index';

export default function* navigator(args) {
  yield fork(itemNavigator, { modelName: 'Sale', actions, editableFields }, args);
}
